import React from "react";

export const ACCENT = "#4f46e5";

export const card: React.CSSProperties = {
  background: "#f5f1ec",
  border: "1px solid #e7dfd4",
  borderRadius: 8,
  padding: "20px 24px",
};

export const panel: React.CSSProperties = { ...card, background: "#fff", padding: 20 };

export const select: React.CSSProperties = {
  padding: "6px 8px",
  borderRadius: 6,
  border: "1px solid #d6cec3",
  fontSize: 14,
  maxWidth: 260,
};

export function formatUsd(n: number): string {
  if (n > 0 && n < 0.01) return "<$0.01";
  return n.toLocaleString("en-US", {
    style: "currency",
    currency: "USD",
    maximumFractionDigits: Math.abs(n) >= 1000 ? 0 : 2,
  });
}
